module.exports = __webpack_public_path__ + "img/campsBig.6cb5cc3e.png";